const routes = {
  PAINTER: '/painter',
  DEALER: '/dealer'
}

export default routes